import notifyError from '../notify-error';
import notifySuccess from '../notify-success';

const handleImpersonate = async ({ $vs, $store, $router, crm, accessToken }) => {
  let person = '';
  let company = crm.client.person.email;

  if (crm.client.person.name && crm.client.person.surname) {
    person = crm.client.person.name + ' ' + crm.client.person.surname;
  }

  if (crm.client.person.company && crm.client.person.company.name) {
    company = crm.client.person.company.name;
  }

  await $store.dispatch('FILTERS/clear', {}, { root: true });

  const data = {
    companyNip: crm?.client?.person?.company?.nip,
    company,
    person,
    parent: crm.parent,
    serviceparent: crm.serviceparent,
    crmId: crm.id,
    crmOriginal: crm.original,
    personData: crm.client.person,
    accessToken,
  };

  await $store.dispatch('auth/switchAccount', data);
  await $router.push({ name: 'account-landing-page' });
  notifySuccess({ $vs, text: 'Konto zmienione na ' + data.company });
};

export default ({ $vs, $store, $router, crm, asIs = false }) => {
  $store.dispatch('CRM_MODULE/impersonate', { crmId: crm.id, asIs })
    .then(({ data }) => handleImpersonate({ $vs, $store, $router, crm, accessToken: data.accessToken }))
    .catch((error) => notifyError({ $vs, text: error.response.data.error }));
};
